export enum InputStatesEnum {
    None, // no check
    Initial, // grey check
    ReadyForConfirmation, // blue check
    Pending, // yellow check
    Confirmed, // green check
    Error,
    NotFinishedPendingTransaction
}